/** Top-bar Help (?) — icon legend modal. */
let helpGuideInited = false;
function getModal() {
    return document.getElementById('help-modal');
}
export function openHelpGuide() {
    var _a;
    const modal = getModal();
    if (!modal)
        return;
    modal.classList.remove('hidden');
    modal.removeAttribute('hidden');
    (_a = document.getElementById('help-modal-close')) === null || _a === void 0 ? void 0 : _a.focus();
}
export function closeHelpGuide() {
    const modal = getModal();
    if (!modal)
        return;
    modal.classList.add('hidden');
    modal.setAttribute('hidden', '');
}
/** Call once from main.tsx on DOMContentLoaded. */
export function initHelpGuide() {
    if (helpGuideInited)
        return;
    helpGuideInited = true;
    const openBtn = document.getElementById('navbar-help-btn');
    const modal = getModal();
    const closeBtn = document.getElementById('help-modal-close');
    const doneBtn = document.getElementById('help-modal-done');
    openBtn === null || openBtn === void 0 ? void 0 : openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openHelpGuide();
    });
    closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.addEventListener('click', () => closeHelpGuide());
    doneBtn === null || doneBtn === void 0 ? void 0 : doneBtn.addEventListener('click', () => closeHelpGuide());
    modal === null || modal === void 0 ? void 0 : modal.addEventListener('click', (e) => {
        if (e.target === modal)
            closeHelpGuide();
    });
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape')
            return;
        if (!modal || modal.classList.contains('hidden'))
            return;
        closeHelpGuide();
    });
}
